import { matchRoutes } from "react-router-dom";
import Home from "../components/Pages/Home";
import Login from "../components/Pages/auth/Login";
import Signup from "../components/Pages/auth/Signup";
import AccountModeSelection from "../components/Pages/auth/AccountModeSelection";
import SignupSuccess from "../components/Pages/auth/SignupSuccess";
import SignupCancel from "../components/Pages/auth/SignupCancel";
import SignupCheckout from "../components/Pages/auth/SignupCheckout";
import ForgotPassword from "../components/Pages/auth/ForgotPassword";
import ResetPassword from "../components/Pages/auth/ResetPassword";
import HelpCenter from "../components/Pages/HelpCenter";
import Pricing from "../components/Pages/Pricing";
import WhyHaastia from "../components/Pages/WhyHaastia";
import About from "../components/Pages/About";
import Contact from "../components/Pages/Contact";
import ExampleBookingPage from "../components/Pages/ExampleBookingPage";
import LegacyServiceRedirect from "../components/Pages/LegacyServiceRedirect";
import LegacyProfileRedirect from "../components/Pages/LegacyProfileRedirect";
import ProfessionalProfile from "../components/customer/ProfessionalProfile";
import BookingManagePage from "../components/Pages/booking/BookingManagePage";
import TermsAndConditions from "../components/Pages/TermsAndConditions";
import PrivacyPolicy from "../components/Pages/PrivacyPolicy";
import BusinessJoinPage from "../pages/join/BusinessJoinPage";

import "./lazyPageStyles";
import LegacySettingsRedirect from "./LegacySettingsRedirect";
import SigninAliasRedirect from "./SigninAliasRedirect";
import { lazyWithReload } from "../utils/lazyWithReload";

// The dashboard, recruiter and admin pages' scripts load on demand, so the
// public site doesn't download them, or the calendar and text editor they
// bring. Their stylesheets stay in the main bundle (see lazyPageStyles.js). The
// dashboard pages share one "dashboard" chunk, so one download covers moving
// between them.
const ProOverview = lazyWithReload(() =>
  import(/* webpackChunkName: "dashboard" */ "../views/professionalView/ProOverview")
);
const Calendar = lazyWithReload(() =>
  import(/* webpackChunkName: "dashboard" */ "../views/professionalView/Calendar")
);
const MyServices = lazyWithReload(() =>
  import(/* webpackChunkName: "dashboard" */ "../views/professionalView/MyServices")
);
const AddServicePage = lazyWithReload(() =>
  import(/* webpackChunkName: "dashboard" */ "../views/professionalView/AddServicePage")
);
const ProfessionalRequests = lazyWithReload(() =>
  import(/* webpackChunkName: "dashboard" */ "../views/professionalView/ProfessionalRequests")
);
const AppointmentDetails = lazyWithReload(() =>
  import(/* webpackChunkName: "dashboard" */ "../views/professionalView/AppointmentDetails")
);
const EntryDetails = lazyWithReload(() =>
  import(/* webpackChunkName: "dashboard" */ "../views/professionalView/EntryDetails")
);
const ProfessionalAvailability = lazyWithReload(() =>
  import(/* webpackChunkName: "dashboard" */ "../views/professionalView/ProfessionalAvailability")
);
const ProfessionalSchedulingLimits = lazyWithReload(() =>
  import(/* webpackChunkName: "dashboard" */ "../views/professionalView/ProfessionalSchedulingLimits")
);
const ProfessionalCustomers = lazyWithReload(() =>
  import(/* webpackChunkName: "dashboard" */ "../views/professionalView/ProfessionalCustomers")
);
const ClientInsights = lazyWithReload(() =>
  import(/* webpackChunkName: "dashboard" */ "../views/professionalView/ClientInsights")
);
const StripeConnectPage = lazyWithReload(() =>
  import(/* webpackChunkName: "dashboard" */ "../views/professionalView/StripeConnectPage")
);
const FinancialActivityPage = lazyWithReload(() =>
  import(/* webpackChunkName: "dashboard" */ "../views/professionalView/FinancialActivityPage")
);
const ProfessionalOnboarding = lazyWithReload(() =>
  import(/* webpackChunkName: "dashboard" */ "../views/professionalView/ProfessionalOnboarding")
);
const TeamSettingsOnboarding = lazyWithReload(() =>
  import(/* webpackChunkName: "dashboard" */ "../views/professionalView/TeamSettingsOnboarding")
);
const ProfessionalWorkLocationSettings = lazyWithReload(() =>
  import(/* webpackChunkName: "dashboard" */ "../views/professionalView/ProfessionalWorkLocationSettings")
);
const ProfessionalSettings = lazyWithReload(() =>
  import(/* webpackChunkName: "dashboard" */ "../views/professionalView/ProfessionalSettings")
);
const ProfessionalVisualEditor = lazyWithReload(() =>
  import(/* webpackChunkName: "dashboard" */ "../views/professionalView/ProfessionalVisualEditor")
);
const ProfessionalBookingQuestions = lazyWithReload(() =>
  import(/* webpackChunkName: "dashboard" */ "../views/professionalView/ProfessionalBookingQuestions")
);
const ProfessionalBookingMessages = lazyWithReload(() =>
  import(/* webpackChunkName: "dashboard" */ "../views/professionalView/ProfessionalBookingMessages")
);
const FeedbackSupportPage = lazyWithReload(() =>
  import(/* webpackChunkName: "dashboard" */ "../pages/FeedbackSupportPage")
);
const TeamPage = lazyWithReload(() =>
  import(/* webpackChunkName: "dashboard" */ "../views/professionalView/TeamPage")
);
const BusinessSettingsPage = lazyWithReload(() =>
  import(/* webpackChunkName: "dashboard" */ "../views/professionalView/BusinessSettingsPage")
);
const ImportPage = lazyWithReload(() =>
  import(/* webpackChunkName: "dashboard" */ "../views/professionalView/import/ImportPage")
);
const ImportWizard = lazyWithReload(() =>
  import(/* webpackChunkName: "dashboard" */ "../views/professionalView/import/ImportWizard")
);
const MoveFromAcuity = lazyWithReload(() =>
  import(/* webpackChunkName: "dashboard" */ "../views/professionalView/import/move/MoveFromAcuity")
);
const AccountSettingsPage = lazyWithReload(() =>
  import(/* webpackChunkName: "dashboard" */ "../views/professionalView/AccountSettingsPage")
);
const RecruiterDashboard = lazyWithReload(() =>
  import(/* webpackChunkName: "recruiter" */ "../pages/recruiter/RecruiterDashboard")
);
const AdminDashboard = lazyWithReload(() =>
  import(/* webpackChunkName: "admin" */ "../views/admin/AdminDashboard")
);
const AdminRecruiters = lazyWithReload(() =>
  import(/* webpackChunkName: "admin" */ "../views/admin/AdminRecruiters")
);
const AdminFoundingReferrals = lazyWithReload(() =>
  import(/* webpackChunkName: "admin" */ "../views/admin/AdminFoundingReferrals")
);
const AdminTrialCoupons = lazyWithReload(() =>
  import(/* webpackChunkName: "admin" */ "../views/admin/AdminTrialCoupons")
);
const AdminSupportTickets = lazyWithReload(() =>
  import(/* webpackChunkName: "admin" */ "../views/admin/AdminSupportTickets")
);
const AdminDiscoveryApplications = lazyWithReload(() =>
  import(/* webpackChunkName: "admin" */ "../views/admin/AdminDiscoveryApplications")
);

export const customerRouteConfig = [
  { path: "/", component: Home },
  { path: "/profile/:userId", component: LegacyProfileRedirect },
  { path: "/login", component: Login },
  { path: "/signin", component: SigninAliasRedirect },
  { path: "/signup", component: AccountModeSelection },
  { path: "/signup/details", component: Signup },
  // Emailed deep link: buildPendingSignupEmail (server/utils/accountEmailTemplates.js)
  // sends the ?pendingSignupId=&token= URL built by createCheckoutEmailLink in
  // server/controllers/auth.js. Also reached from Login.js on reactivate-and-resubscribe.
  { path: "/signup/checkout", component: SignupCheckout },
  { path: "/signup/success", component: SignupSuccess },
  { path: "/signup/cancel", component: SignupCancel },
  { path: "/password/forgot", component: ForgotPassword },
  { path: "/password/reset", component: ResetPassword },
  { path: "/service/:id", component: LegacyServiceRedirect },
  { path: "/help", component: HelpCenter },
  { path: "/pricing", component: Pricing },
  { path: "/why-haastia", component: WhyHaastia },
  { path: "/about", component: About },
  { path: "/contact", component: Contact },
  { path: "/example", component: ExampleBookingPage },
  { path: "/p/:username", component: ProfessionalProfile },
  { path: "/professional/:id", component: ProfessionalProfile },
  { path: "/bookings/manage/:token", component: BookingManagePage },
  { path: "/terms", component: TermsAndConditions },
  { path: "/privacy", component: PrivacyPolicy },
  { path: "/join/business", component: BusinessJoinPage },
];

export const professionalRouteConfig = [
  { path: "/onboarding", component: ProfessionalOnboarding, providerRequired: true },
  { path: "/onboarding/team", component: ProfessionalOnboarding, providerRequired: true },
  { path: "/onboarding/team-settings", component: TeamSettingsOnboarding, providerRequired: true },
  {
    path: "/onboarding/business-details",
    component: () => <ProfessionalWorkLocationSettings onboarding />,
    providerRequired: true,
  },
  { path: "/booking-page-builder", component: ProfessionalSettings, providerRequired: true },
  { path: "/booking-page-visual-editor", component: ProfessionalVisualEditor, providerRequired: true },
  { path: "/profile-appearance", component: ProfessionalSettings, providerRequired: true },
  { path: "/booking-questions", component: ProfessionalBookingQuestions, providerRequired: true },
  { path: "/pro/settings/booking-messages", component: ProfessionalBookingMessages, providerRequired: true },
  { path: "/add-service", component: AddServicePage, workspaceSection: "services", managerCapability: "canManageServices" },
  { path: "/pro/overview", component: ProOverview, workspaceAllowed: true },
  { path: "/calendar", component: Calendar, workspaceSection: "calendar" },
  { path: "/customers", component: ProfessionalCustomers, workspaceSection: "clients" },
  { path: "/customers/:customerId", component: ProfessionalCustomers, workspaceSection: "clients" },
  { path: "/client-insights", component: ClientInsights, workspaceSection: "insights" },
  { path: "/services", component: MyServices, workspaceSection: "services" },
  { path: "/availability/limits", component: ProfessionalSchedulingLimits, providerRequired: true },
  { path: "/availability", component: ProfessionalAvailability, providerRequired: true },
  { path: "/bookings", component: ProfessionalRequests, workspaceSection: "bookings" },
  // An appointment the business added itself; it shows on the Calendar and on
  // Bookings, so either section opens it.
  { path: "/bookings/entry/:entryId", component: EntryDetails, workspaceSection: ["bookings", "calendar"] },
  { path: "/bookings/:bookingId", component: AppointmentDetails, workspaceSection: "bookings" },
  { path: "/payments/connect", component: StripeConnectPage, providerRequired: true },
  { path: "/payments/activity", component: FinancialActivityPage, providerRequired: true },
  { path: "/pro/settings", component: BusinessSettingsPage, workspaceSection: "settings" },
  { path: "/pro/settings/business", component: LegacySettingsRedirect, workspaceSection: "settings" },
  // workspaceOptional: AccountSettingsPage reads no activeBusinessId, and it is
  // where a user changes their password or deletes their account. It must stay
  // reachable when the workspace fails to resolve, or a broken workspace locks
  // the user out of their own account.
  { path: "/pro/settings/account", component: AccountSettingsPage, workspaceSection: "settings", workspaceOptional: true },
  {
    path: "/pro/settings/work-location",
    component: () => <LegacySettingsRedirect tab="business" section="location" />,
    workspaceSection: "settings",
  },
  // Bringing a client list across is a manager's job, so these need the
  // capability as well as the settings section.
  {
    path: "/pro/import",
    component: ImportPage,
    workspaceSection: "settings",
    managerCapability: "canImportBusinessData",
  },
  // The guided "Move from Acuity" flow. Before :batchId so "move" isn't read
  // as an import id.
  {
    path: "/pro/import/move",
    component: MoveFromAcuity,
    workspaceSection: "settings",
    managerCapability: "canImportBusinessData",
  },
  {
    path: "/pro/import/:batchId",
    component: ImportWizard,
    workspaceSection: "settings",
    managerCapability: "canImportBusinessData",
  },
  { path: "/feedback", component: FeedbackSupportPage, workspaceAllowed: true },
  { path: "/team", component: TeamPage, workspaceSection: "team" },
];

// Two dashboard paths routed to the same page component share one mounted page:
// React keeps the instance, and whatever is typed into it, across the move, as
// between /booking-page-builder and /profile-appearance.
const professionalPages = professionalRouteConfig.map(({ path, component }) => ({ path, component }));
const professionalPageAt = (pathname) =>
  matchRoutes(professionalPages, pathname)?.[0]?.route.component || null;

export const isSameProfessionalPage = (fromPathname, toPathname) => {
  const page = professionalPageAt(fromPathname);
  return Boolean(page) && page === professionalPageAt(toPathname);
};

export const recruiterRouteConfig = [
  { path: "/recruiter", component: RecruiterDashboard },
];

export const adminRouteConfig = [
  { path: "/admin", component: AdminDashboard },
  { path: "/admin/recruiters", component: AdminRecruiters },
  { path: "/admin/founding-referrals", component: AdminFoundingReferrals },
  { path: "/admin/trial-coupons", component: AdminTrialCoupons },
  { path: "/admin/discovery-applications", component: AdminDiscoveryApplications },
  { path: "/admin/support-tickets", component: AdminSupportTickets },
];
